import { YOO_FINDS_CDN } from "@/common";

const baseUrl = `${YOO_FINDS_CDN}/pc/christmas`;
export const ChristmasBannerSrc = `${baseUrl}/bannerV2.png`;
export const ChristmasIconSrc = `${baseUrl}/christmas-icon.png`;
export const ChristmasBannerTop = `${baseUrl}/banner-top.png`;
export const ChristmasBannerBottom = `${baseUrl}/banner-bottom.png`;
